// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".first-box[data-v-54bffadb]{background:linear-gradient(180deg,#09bec7,#05b8c0 66.94%,#00a8af)}.circular-logo[data-v-54bffadb]{position:absolute;top:200px;left:-50px;z-index:1}.white-text[data-v-54bffadb]{color:#fff}@media screen and (max-width:768px){.circular-logo[data-v-54bffadb]{top:0;right:10px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
